import { Outlet, useLocation, Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { cn } from '../lib/utils'

export default function Layout() {
  const location = useLocation()
  const isDashboard = location.pathname === '/'

  return (
    <div className="min-h-screen min-h-[100dvh] bg-neutral-50 dark:bg-neutral-950">
      {/* Back button - inner pages only */}
      {!isDashboard && (
        <div className="sticky top-0 z-30 bg-white/95 dark:bg-neutral-950/95 backdrop-blur-xl border-b border-neutral-200 dark:border-neutral-800 px-4 py-2.5">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white transition-colors"
          >
            <ArrowRight className="w-4 h-4" />
            بازگشت به داشبورد
          </Link>
        </div>
      )}

      {/* Page Content */}
      <main className={cn(
        'flex-1 overflow-auto',
        isDashboard ? '' : 'pb-20'
      )}>
        <Outlet />
      </main>
    </div>
  )
}
